import {Routes} from '@angular/router';
import {ActivitiesHomeComponent} from '@modules/activities/core/activities-home/activities-home.component';
import {LessonsInChaptersListComponent} from '@modules/activities/core/activities-home/lessons-in-chapters-list/lessons-in-chapters-list.component';
import {PeriodListComponent} from '@modules/activities/core/activities-home/period-list/period-list.component';
import {CanShowLessonListGuard} from '@modules/activities/core/lessons/lessons-list/can-show-lesson-list.guard';
import {CommunityListComponent} from '@modules/activities/core/lessons/lessons-list/community-list/community-list.component';
import {LessonsListComponent} from '@modules/activities/core/lessons/lessons-list/lessons-list.component';
import {OnlyLessonLessonsListComponent} from '@modules/activities/core/lessons/lessons-list/only-lesson-lessons-list/only-lesson-lessons-list.component';
import {OnlyModelLessonsListComponent} from '@modules/activities/core/lessons/lessons-list/only-model-lessons-list/only-model-lessons-list.component';
import {UserLessonsComponent} from '@modules/activities/core/lessons/lessons-list/user-lessons/user-lessons.component';
import {LessonsComponent} from '@modules/activities/core/lessons/lessons.component';
import {ListOfActivitiesComponent} from '@modules/activities/core/lessons/list-of-activities/list-of-activities.component';
import {IsUserLogged} from '../../../../guards';

export const routes: Routes = [
    {
        path: 'lessons',
        canActivate: [IsUserLogged],
        children: [
            {
                path: 'home',
                component: ActivitiesHomeComponent,
            },
            {
                path: 'grade/:gradeId/concept/:conceptId',
                component: PeriodListComponent,
            },
            {
                path: 'grade/:gradeId/concept/:conceptId/chapter/:chapterId',
                component: LessonsInChaptersListComponent,
            },
            {
                path: 'list',
                canActivate: [CanShowLessonListGuard],
                children: [
                    {
                        path: '',
                        component: LessonsListComponent,
                    },
                    {
                        path: 'filters/:title',
                        component: LessonsListComponent
                    },
                    {
                        path: 'search',
                        component: LessonsListComponent
                    },
                    {
                        path: 'lessons',
                        component: OnlyLessonLessonsListComponent
                    },
                    {
                        path: 'models',
                        component: OnlyModelLessonsListComponent
                    },
                    {
                        path: 'algebra',
                        component: OnlyModelLessonsListComponent
                    },
                    {
                        path: 'geometry',
                        component: OnlyModelLessonsListComponent
                    },
                    {
                        path: 'community',
                        component: CommunityListComponent
                    },
                    {
                        path: 'recommendation',
                        loadComponent: () => import('@modules/activities/core/lessons/lessons-list/recommendation/recommendation.component').then(m => m.RecommendationComponent)
                    },
                    {
                        path: 'user-lessons',
                        component: UserLessonsComponent
                    }]
            },
            {
                path: ':lessonId',
                children: [
                    {
                        path: '',
                        loadComponent: () => import('@modules/activities/core/lessons/lesson-view/lesson-view.component').then(m => m.LessonViewComponent)
                    },
                    {
                        path: 'page',
                        loadComponent: () => import('@modules/activities/core/lessons/lesson-view/lesson-view.component').then(m => m.LessonViewComponent)
                    },
                    {
                        path: 'pagejunior',
                        loadComponent: () => import('@modules/activities/core/lessons/lesson-view/lesson-view.component').then(m => m.LessonViewComponent)
                    },
                    {
                        path: 'pagecollege',
                        loadComponent: () => import('@modules/activities/core/lessons/lesson-view/lesson-view.component').then(m => m.LessonViewComponent)
                    },
                    {
                        path: 'pageexplorer',
                        loadComponent: () => import('@modules/activities/core/lessons/lesson-view/lesson-view.component').then(m => m.LessonViewComponent)
                    },
                    {
                        path: 'player',
                        component: LessonsComponent,
                        children: [
                            {
                                path: 'recap',
                                loadComponent: () => import('@modules/activities/core/lessons/lessons-recap/lessons-recap.component').then(m => m.LessonsRecapComponent)
                            },
                            {
                                path: 'reward',
                                loadComponent: () => import('@modules/activities/core/reward-page/reward-page.component').then(m => m.RewardPageComponent)
                            }, {
                                path: 'summary',
                                loadComponent: () => import('@modules/activities/core/lessons/summary-sub-lesson/summary-sub-lesson.component').then(m => m.SummarySubLessonComponent)
                            },
                            {
                                path: '',
                                loadChildren: () => import('@modules/activities/core/player-components/players.module').then(m => m.PlayersModule)
                            }
                        ]
                    },
                    {
                        path: 'editor',
                        children: [
                            {
                                path: '',
                                loadChildren: () => import('@modules/activities/core/lessons/editor/editor.module').then(m => m.EditorModule)
                            }
                        ]
                    },
                    {
                        path: 'activities',
                        component: ListOfActivitiesComponent
                    },
                    {
                        path: 'activities/:subLessonIdentifier', // On le double pour pouvoir forcer un des onglets du composant
                        component: ListOfActivitiesComponent
                    },
                    {
                        path: '**',
                        pathMatch: 'full',
                        redirectTo: 'player'
                    }
                ]
            }
        ]
    },
];